"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
// (c) Zammo Inc.
exports.palette = {
    qnaBlue: '#d4e3fe',
    lightBlue: '#0062b2',
    lightBlue1: '#1976d2',
    mediumBlue: '#008cff',
    mediumBlue1: '#00356f',
    darkBlue: '#004188',
    gray: '#aaaaaa',
    gray1: '#b2b2b2',
    gray2: '#797775',
    lightGray: '#f6f9fa',
    mediumGray: '#e8e8e8',
    darkGray: '#555555',
    pink: '#ff0074',
    red: '#ee1717',
    lightRed: '#de3607',
    blue: '#008cff',
    tonedGreen: '#22af36',
    lightBlack: '#373a3c',
    black: '#222222',
    border: '#d8d8d8',
    turquoise: '#00ddff',
    purple: '#8200a3',
    mediumYellow: '#fae060',
    paleYellow: '#f3ff97',
    white: '#ffffff',
};
//# sourceMappingURL=variables.js.map